const handleUsers = ((jQuery) => {
  'use strict'

  var dataTable, deleteUrl, formData, uid;

  const initDatatable = function () {

    dataTable = jQuery('#admin_users_table').dataTable({
      language: {
        url: '/vendor/datatables/' + AppLocale + '.json'
      },
      paging: true,
      lengthChange: false,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: false,
      responsive: true,
      dom: 'T<"clear">lfrtip',
      sPaginationType: "full_numbers",
      aoColumnDefs: [{
        'bSortable': false,
        'searchable': false,
        'aTargets': ['no-search'],
        'bTargets': ['no-sort'],
      }],
      initComplete: function () {
        jQuery('.data-table').toggleClass('d-none');
      }
    });
  };

  const initActions = function () {
    jQuery('#confirmDelete').on('show.bs.modal', function (e) {
      var $this = jQuery(this);
      var row = jQuery(e.relatedTarget);
      var message = row.attr('data-message');
      var title = row.attr('data-title');
      uid = row.attr('data-uid');
      deleteUrl = row.attr('data-href');
      formData = row.prev().serialize();
      $this.find('.modal-body p').text(message);
      $this.find('.modal-title').text(title);
    }).find('#confirm').on('click', function () {
      $.ajax({
        type: 'DELETE',
        url: deleteUrl,
        data: formData,
        dataType: 'json',
        encode: true,
      }).done(function (data) {
        jQuery('#confirmDelete').modal('toggle');
        if (typeof data.success !== 'undefined') {
          toastr.success(data.success);
          dataTable.api().row(jQuery('#user-' + uid)).remove().draw();
          return;
        }
        toastr.error(data.error);
      });
    });

    jQuery('#form-import-user').on('submit', function () {
      jQuery('#importUserModal').modal('toggle');
    });
  };


  jQuery(function () {
    initDatatable();
    initActions();
  });

})(jQuery);
